import React, { useState } from "react";

const CustomSlider = ({ percentage, setPercentage }) => {
  return (
    <div className="w-full px-4">
      <div className="flex items-center gap-4">
        <span className="text-sm">0%</span>

        {/* Slider Wrapper */}
        <div className="relative w-full">
          {/* Progress Track */}
          <div
            className="absolute top-1/2 transform -translate-y-1/2 h-[6px] rounded-lg bg-[#2D1A4D]"
            style={{ width: `${percentage}%` }}
          />
          {/* Base Track */}
          <div className="h-[6px] bg-gray-300 rounded-lg" />
          {/* Slider Input */}
          <input
            type="range"
            min="0"
            max="100"
            value={percentage}
            onChange={(e) => setPercentage(Number(e.target.value))}
            className="
              absolute top-0 left-0 w-full h-[6px] opacity-0 cursor-pointer
              appearance-none
            "
          />
          {/* Thumb (overlayed manually) */}
          <div
            className="absolute top-1/2 transform -translate-y-1/2 w-4 h-4 bg-[#2D1A4D] rounded-full pointer-events-none"
            style={{ left: `calc(${percentage}% - 8px)` }}
          />
        </div>

        <span className="text-sm">100%</span>
      </div>
    </div>
  );
};

export default CustomSlider;
